import React, {useId} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Divider, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import lazyLoadable from '../../../utils/lazy-loadable'
import ReviewOverviewSkeleton from '../../../components/review-overview/skeleton'

const LazyBVProductReviewOverview = lazyLoadable(
    () => import('../../../components/bazaarvoice/review-overview'),
    {
        ssr: false,
        fallback: <ReviewOverviewSkeleton />
    }
)

const Reviews = ({product, onCloseReviewModal, isOpenReviewModal, onOpenReviewModal}) => {
    const id = useId()
    const styles = useStyleConfig('ReviewOverview', {variant: 'default'})
    return (
        <Flex {...styles.container}>
            <Text as="h2" {...styles.heading} tabIndex="-1" id={id}>
                <FormattedMessage defaultMessage="Review Snapshot" id="reviews.overview" />
            </Text>
            <Divider {...styles.divider} />
            <LazyBVProductReviewOverview
                product={product}
                isOpenReviewModal={isOpenReviewModal}
                onCloseReviewModal={onCloseReviewModal}
                onOpenReviewModal={onOpenReviewModal}
            />
        </Flex>
    )
}

Reviews.propTypes = {
    product: PropTypes.object,
    isOpenReviewModal: PropTypes.bool,
    onCloseReviewModal: PropTypes.func,
    onOpenReviewModal: PropTypes.func
}

export default Reviews
